import axios from 'axios';
import {IHash} from "./framework/CommonInterfaces";
import {SimRunes, ChampionRunes} from "./calculation/CalculationObjects";
import * as _ from 'lodash';
import {SimSkillOrder} from "./calculation/SkillOrder";
import {AbilityInfo} from "./calculation/AbilityInfo";
import {ComboInfo} from "./ComboInfo";




interface ChampionRunesRaw extends ChampionRunes{
	runes:any;
}


export default class GoogleSheetDB{

	static rawData:any;

	static skillOrders:IHash<SimSkillOrder[]> = {};
	static runes:IHash<SimRunes> = {};
	static championRunes:IHash<ChampionRunes[]>={};
	static championAbilities:IHash<AbilityInfo[]> = {};
	static abilitiesByName:IHash<AbilityInfo> = {};
	static championCombos:IHash<ComboInfo[]> = {};


	static loadP(){
		console.log("loading google sheet db");
		return (async() => {
			let url = `https://lol-content-dumps.s3.amazonaws.com/laningmeta.json`;
			let response:any = await axios.get(url);

			let data = response.data;

			//setup the skill orders
			let skillOrdersRaw:SimSkillOrder[] = data.SkillOrders;
			for (let i = 0; i < skillOrdersRaw.length; i++) {
				let skillOrder = skillOrdersRaw[i];

				if(GoogleSheetDB.skillOrders[skillOrder.riotName] == undefined){
					GoogleSheetDB.skillOrders[skillOrder.riotName] = [];
				}

				GoogleSheetDB.skillOrders[skillOrder.riotName].push(skillOrder);
			}

			//setup the runes
			GoogleSheetDB.runes = (_.keyBy(data.Runes,'name') as any);


			//setup the champion runes
			let championRunesRaw:ChampionRunesRaw[] = data.ChampionRunes;
			for (let i = 0; i < championRunesRaw.length; i++) {
				let cr = championRunesRaw[i];

				if(GoogleSheetDB.championRunes[cr.riotName] == undefined){
					GoogleSheetDB.championRunes[cr.riotName] = [];
				}

				cr.runes = (GoogleSheetDB.runes[cr.runes] as any);
				GoogleSheetDB.championRunes[cr.riotName].push((cr as any));
			}

			//setup the abilities
			let abilitiesRaw:AbilityInfo[] = data.Abilities;
			for (let i = 0; i < abilitiesRaw.length; i++) {
				let abil = abilitiesRaw[i];

				if(GoogleSheetDB.championAbilities[abil.championName] == undefined){
					GoogleSheetDB.championAbilities[abil.championName] = [];
				}

				GoogleSheetDB.championAbilities[abil.championName].push(abil);
				GoogleSheetDB.abilitiesByName[abil.name] = abil;
			}


			//setup the combos
			let combosRaw:any[] = data.Combos;
			for (let i = 0; i < combosRaw.length; i++) {
				let comboRaw = combosRaw[i];

				let abilities:any[] = [];
				for(let abilCount = 0; abilCount < 20; abilCount++){
					let val = comboRaw["ability" + abilCount];
					if(!val) break;

					let abil = GoogleSheetDB.abilitiesByName[val];
					if(!abil) throw new Error(`can't find ability with name ${val}, this should never happen`);

					abilities.push(abil);
				}

				comboRaw.abilities = abilities;

				if(GoogleSheetDB.championCombos[comboRaw.champName] == undefined){
					GoogleSheetDB.championCombos[comboRaw.champName]=[];
				}
				GoogleSheetDB.championCombos[comboRaw.champName].push(comboRaw);
			}




		})();
	}

	static getSkillOrdersForChampion(riotName:string):SimSkillOrder[]{
		return GoogleSheetDB.skillOrders[riotName];
	}

	static getDefaultSkillOrdersForChampion(riotName:string):SimSkillOrder{
		let skillOrdersForChampion = this.getSkillOrdersForChampion(riotName);
		if (skillOrdersForChampion == undefined){
			return null;
		}
		return skillOrdersForChampion.filter(so=>so.default)[0];
	}

	static getChampionRunesForChampion(riotName:string):ChampionRunes[]{
		return GoogleSheetDB.championRunes[riotName];
	}

	static getDefaultChampionRunesForChampion(riotName:string):ChampionRunes{
		let championRunesForChampion = this.getChampionRunesForChampion(riotName);
		if (championRunesForChampion == undefined){
			return null;
		}
		return championRunesForChampion.filter(cr=>cr.default)[0];
	}

	static getAbilityByName(abilityName:string):AbilityInfo{
		return GoogleSheetDB.abilitiesByName[abilityName];
	}

	static getChampionAbilities(riotName:string):AbilityInfo[]{
		return GoogleSheetDB.championAbilities[riotName];
	}

	static getChampionCombos(riotName:string):ComboInfo[]{
		return GoogleSheetDB.championCombos[riotName];
	}
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/fbobjects/GoogleSheetDB.ts